<template>
  <div class="mt-4" :class="isSushi && 'montserrat-500'">
    <h4 :class="{'lined-headline': canPayByOtherThanCard}">
      {{ canPayByOtherThanCard ? $t('message.orPayWithCard') : $t('message.payment') }}
    </h4>
    <template
        v-if="!dbuser || !this.savedCards || this.savedCards.length == 0"
    >
      <div id="payment-container">
        <card-component ref="cardInfo" :edit-model="editModel"  :isSushi="isSushi"/>
        <div v-if="user" class="form-row">
          <div class="custom-control custom-radio col-md-8 ml-4">
            <input
                id="saveCardInput"
                type="checkbox"
                name="customCheckbox"
                class="custom-control-input"
                @input="val => $emit('save-credit', val.target.checked)"
            />
            <label
                class="custom-control-label"
                for="saveCardInput"
                :class="isSushi && 'montserrat-500'"
            >{{ $t('message.saveCardForNextTime') }}</label>
          </div>
        </div>
      </div>
    </template>
    <template v-if="this.savedCards.length">
      <div class="form-row">
        <div @click="$emit('setPaymentMethod', 20)" class="form-group col-md-12 col-sm-12 col-lg-12 col-xl-6">
          <vselect
              :options="this.savedCards"
              :searchable="false"
              :clearable="false"
              v-model="selectedCard"
              label="ElidedPan"
          >
            <template slot="option" slot-scope="option">
              <div v-if="option.ElidedPan" class="payment-card py-2">
                <span
                    :style="{ 'background-image': absoluteUrl(option.CardType) }"
                    :class="option.CardType | cardName"
                >{{ option.ElidedPan | formatCard }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <span
                  v-if="option.ElidedPan"
                  :class="option.CardType"
                  style="float:left;margin-right:10px"
                  class="material-icons"
              >credit_card</span>
              {{ option.ElidedPan | formatCard }}
            </template>
          </vselect>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { $$ } from "./../../../../sharedscripts/OO_jquery";
import vselect from "vue-select";
import { wcconfig } from "../../../../../wcConfig.js";
import CardComponent from "../../../shared/CardComponent";
import { getCards } from '../../../../api/payment/DefaultPaymentHandler';
function removeNoise(value) {
  let index = value.indexOf("card");
  if (index === -1) {
    return value;
  } else {
    return value.substring(0, index);
  }
}
export default {
  components: {
    vselect,
    CardComponent
  },
  filters: {
    cardName: removeNoise
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    dbuser: {
      type: Object,
      default: () => {}
    },
    editModel: {
      type: Object,
      default: () => {}
    },
    canPayByOtherThanCard: {
      type: Boolean,
      default: false,
    },
    isSushi : {
      type: Boolean
    },
    selectedPaymentMethod : {
        type : Number,
        default:  null
    },
    customerID: {
      type: String,
      default: "",
    },
    storeID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedCard: {},
      savedCards: [],
    };
  },
  async mounted() {
    if (
        window.location.protocol == "http:" &&
        window.location.hostname != "localhost"
    ) {
      $$("#payment-container:input").attr("disabled", true);
    }
    if (this.customerID) {
      const response = await getCards(this.customerID, this.storeID);
      if (!response.error) {
        response.cards.forEach((card) => {
          this.savedCards.push({
            CardIdentifier: card.id,
            ElidedPan: `XXXXXXXXXXXX${card.card.last4}`,
            CardType: card.card.brand
          });
        });
      }
    }
    if (
      this.dbuser &&
      this.savedCards.length
    ) {
      this.selectedCard = this.savedCards[0];
    }
  },
  watch: {
    dbuser() {
      if (
        this.dbuser &&
        this.savedCards.length
      ) {
        this.selectedCard = this.savedCards[0];
      }
    },
    selectedCard(newValue) {
      this.editModel.SelectedCard = newValue;
      this.setCardNumber(newValue);
    }
  },

  methods: {
    ...mapActions(["setCardNumber"]),
    validate() {
      return this.$validator.validateAll();
    },
    cardInfoValidate() {
      if (this.$refs.cardInfo) return this.$refs.cardInfo.validate();
      else return null;
    },
    absoluteUrl(cardType) {
      if (!this.isWC()) return "";
      let card = removeNoise(cardType);
      switch (card) {
        case "master":
          return "url(" + wcconfig.assets.master + ") !important";
        case "visa":
          return "url(" + wcconfig.assets.visa + ") !important";
        default:
          return "";
      }
    }
  }
};
</script>
